var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_43755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 5.07043H16.381C16.0785 5.07043 15.8171 5.17405 15.619 5.34624C15.4072 5.16446 15.1362 5.06637 14.8571 5.07043H2.66667C2.00457 5.07043 1.52381 5.5512 1.52381 6.21329V27.5466C1.52381 28.2087 2.00457 28.6895 2.66667 28.6895H14.8571C15.1596 28.6895 15.421 28.5859 15.619 28.4137C15.8171 28.5859 16.0785 28.6895 16.381 28.6895H28.5714C29.2335 28.6895 29.7143 28.2087 29.7143 27.5466V6.21329C29.7143 5.5512 29.2335 5.07043 28.5714 5.07043ZM14.8571 27.9276H2.66667C2.42819 27.9276 2.28571 27.7851 2.28571 27.5466V6.21329C2.28571 5.97481 2.42819 5.83234 2.66667 5.83234H14.8571C15.0956 5.83234 15.2381 5.97481 15.2381 6.21329V27.5466C15.2381 27.7851 15.0956 27.9276 14.8571 27.9276ZM28.9524 27.5466C28.9524 27.7851 28.8099 27.9276 28.5714 27.9276H16.381C16.1425 27.9276 16 27.7851 16 27.5466V6.21329C16 5.97481 16.1425 5.83234 16.381 5.83234H28.5714C28.8099 5.83234 28.9524 5.97481 28.9524 6.21329V27.5466ZM30.8571 6.59424C30.7561 6.59424 30.6592 6.63438 30.5878 6.70582C30.5163 6.77726 30.4762 6.87416 30.4762 6.9752V26.7847C30.4762 26.8858 30.5163 26.9827 30.5878 27.0541C30.6592 27.1255 30.7561 27.1657 30.8571 27.1657C30.9582 27.1657 31.0551 27.1255 31.1265 27.0541C31.198 26.9827 31.2381 26.8858 31.2381 26.7847V6.9752C31.2381 6.87416 31.198 6.77726 31.1265 6.70582C31.0551 6.63438 30.9582 6.59424 30.8571 6.59424ZM0.380952 27.1657C0.481987 27.1657 0.578884 27.1255 0.650326 27.0541C0.721769 26.9827 0.761905 26.8858 0.761905 26.7847V6.9752C0.761905 6.87416 0.721769 6.77726 0.650326 6.70582C0.578884 6.63438 0.481987 6.59424 0.380952 6.59424C0.279918 6.59424 0.183021 6.63438 0.111578 6.70582C0.0401359 6.77726 0 6.87416 0 6.9752L0 26.7847C0 26.8858 0.0401359 26.9827 0.111578 27.0541C0.183021 27.1255 0.279918 27.1657 0.380952 27.1657Z",
    fill: "#6374FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 11,
    height: 4,
    rx: 1,
    fill: "#6374FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 11,
    height: 4,
    rx: 1,
    fill: "#6374FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_43755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24.381,
    fill: "white",
    transform: "translate(0 4.30859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSection);
export default __webpack_public_path__ + "static/media/book_section.7f88b94b654010a58e0b48a725e581ef.svg";
export { ForwardRef as ReactComponent };